import { render, staticRenderFns } from "./ClimateOnlineRecommendations.vue?vue&type=template&id=70a6a91f"
import script from "./ClimateOnlineRecommendations.vue?vue&type=script&lang=js"
export * from "./ClimateOnlineRecommendations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports